import client from './client';

export default {
  create(params) {
    return client.post('/managers')
      .send(params)
      .end();
  },

  updateSelf(params) {
    return client.patch('/managers/self')
      .send(params)
      .end();
  },

  validate(params) {
    params.validateOnly = true;

    return client.post('/managers')
      .send(params)
      .end();
  },

  informPremiumFollowers(params) {
    return client.post('/managers/inform_premium_followers').send(params).end();
  }
};



// WEBPACK FOOTER //
// ./app/sources/api/managerAPI.js